import SchemaMarkup from "../Components/SchemaMarkup";

const BreadcrumbSchema = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",

    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",

      "position": index + 1,

      "name": item.name,

      ...(item.url && {
        "item": item.url
      })
    }))
  };

  return <SchemaMarkup data={schema} />;
};

export default BreadcrumbSchema;